const UNIT_LABELS = {
  years: { full: 'YEAR', short: 'y' },
  months: { full: 'MONTH', short: 'm' },
  days: { full: 'DAY', short: 'd' },
  hours: { full: 'HOUR', short: 'h' },
  minutes: { full: 'MINUTE', short: 'm' },
  seconds: { full: 'SECOND', short: 's' },
};

const MAX_UNIT_CIRCLE_VALUES = {
  years: 100,
  months: 12,
  days: 30,
  hours: 24,
  minutes: 60,
  seconds: 60,
};

// Add a zero prefix to values less than 10
const zeroPrefixHelper = (value = 0) => (value < 10 ? `0${value}` : value.toString());

// Get the label for the unit
const getLabelHelper = (unitName, value) => {
  const labelObj = UNIT_LABELS[unitName];
  // pluralize for full words
  return value === 1 ? labelObj.full : `${labelObj.full}S`;
};

/* Helper function to get the label based on the unit name
 * @param {string color} color - The color to convert to RGBA
 * @param {alpha} alpha - The alpha value to apply to the color
 * @returns {string} - The RGBA color string
 */
const toRgba = (color, alpha) => {
  const rgbMatch = color.match(
    /rgba?\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)(?:\s*,\s*([\d.]+))?\s*\)/,
  );

  if (rgbMatch) {
    const [, r, g, b] = rgbMatch;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Return original color if it doesn't match the expected format
  return color;
};

// Handle unit values for display
const handleUnitValue = (unit) => {
  // If the unit is hours, minutes, or seconds, prefix with zero if less than 10
  if (['hours', 'minutes', 'seconds'].includes(unit.name)) {
    return zeroPrefixHelper(unit.value);
  }
  // For other units, return the value as is
  return unit.value;
};

module.exports = {
  UNIT_LABELS,
  MAX_UNIT_CIRCLE_VALUES,
  zeroPrefixHelper,
  getLabelHelper,
  handleUnitValue,
  toRgba,
};
